/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, {useEffect} from "react";
import {
  Card,
  CardBody,
  Pagination
} from "../../../../../_metronic/_partials/controls";
import {useIntl} from "react-intl";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {EntityCard} from "../../../EmyProducts/componants/EntityCard";
import {ModuleProvider} from "../../../EmyProducts/ModuleContext";
import {CONTEXT} from "../../../EmyProducts/helpers/ModuleHelpers";
import {actionTypes} from "../../../EmyProducts/_redux/slice";
import {useMetadata} from "../../../../../_emywork/AEPagination";
import {fetchEntities} from "../../../EmyProducts/_redux/actions";

export function EmyProducts({ user_id }) {
  const {formatMessage} = useIntl();
  const dispatch = useDispatch();
  const { entities, meta } = useSelector(
    s => {
      return s[CONTEXT][actionTypes.UserList]
    },
    shallowEqual
  );
  const metadata = useMetadata(meta);
  const { page, perPage, sortAsc, filters, sortField, select, setFilters} = metadata;

  const getEntities = () => {
    if(filters.user_id) dispatch(fetchEntities(metadata.toAEMetadata(), actionTypes.UserList));
  }

  useEffect(() => {
    getEntities()
  }, [dispatch, page, perPage, filters, select, sortField, sortAsc]);

  useEffect(() => {
    setFilters({user_id: user_id})
  }, []);

  return (
    <ModuleProvider>
      <Card>
        <CardBody>
          <div className="font-size-h2 font-weight-bold">
            {formatMessage({id: 'EMY_PRODUCTS'})}
          </div>
        </CardBody>
      </Card>
      <div className='row'>
        {
          entities.map(r=>(
            <div key={r.id} className={'col-xl-4 col-lg-6 col-md-4 col-sm-6'}>
              <EntityCard entity={r} size={"md"} showUser={false}/>
            </div>
          ))
        }
      </div>
      {/*<Filter {...metadata}/>*/}

      <Pagination {...metadata} />

    </ModuleProvider>
  )

}
